import "../styles.css";
import React, { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  clearData,
  createInitialOrder,
  fetchReferralCode,
  getJumioVerificationUrl,
  setData,
  changeFormField,
  getJumioSessionToken,
  // getJumioVerificationFulfillmentUrl
  // getSignPassLinkUrl
} from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectOrderParams,
  makeSelectPayMonthlyItems,
  makeSelectPayTodayItems,
  makeSelectDeliveryDetailsItems,
  makeSelectReferralCode,
  makeSelectPaymentRequest,
  makeSelectOrderSummaryForm,
  makeSelectOrderSummaryFormInitialValues,
  makeSelectOrderSummaryPayload,
  makeSelectESigned,
  makeSelectPaymentModes,
  makeSelectFormattedSelectedNumber,
  makeSelectAddons,
  makeSelectPlanDetails,
  makeSelectDefaultPromoCodeOffers,
  makeSelectSessionToken,
  makeSelectIosDevice,
  makeSelectJumioRedirectUrl,
  makeSelectSadOrderParams,
  makeSelectOrder,
  makeSelectSimCount,
  makeSelectJumioData,
  makeSelectJumioSessionToken,
  makeSelectValidateIccId,
  makeSelectEKYCMessageData,
  makeSelectMyInfo,
  makeSelectMyInfoIsUsed,
  makeSelectMyInfoDetails,
  makeSelectSignPass,
  makeSelectJumioIsUsed,
  makeSelectGuestOrder,
  makeSelectIsWalletPromoCode,
  makeSelectEkycValidation,
  makeSelectMyInfoIsInvalid,
  makeSelectAppSettings
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import forEach from "lodash/forEach";
import {
  gotoUrl,
  setMyInfoFieldToClear,
  buildJumioParams
} from "utils/helpers";
import {
  forms,
  paths,
} from "utils/constants";
import { makeSelectBillingEmailCompleted, makeSelectIsPrimaryDetailsCompleted, makeSelectIsSecondaryDetailsCompleted, makeSelectSimCountNewAndTransfer } from "ducks/selectors/planService";

const AccountHolderHOC = Component =>
  function Comp(props) {
    console.log("PRTOPS" , props)
    return <Component {...props} />
  };

const mapStateToProps = createStructuredSelector({
  formValues: makeSelectOrderSummaryForm(),
  payload: makeSelectOrderSummaryPayload(),
  order: makeSelectOrder(),
  paymentRequest: makeSelectPaymentRequest(),
  orderParams: makeSelectOrderParams(),
  sadOrderParams: makeSelectSadOrderParams(),
  isCreatingOrder: makeSelectIsFetchingData("order"),
  isIosDevice: makeSelectIosDevice(),
  nextPage: makeSelectJumioRedirectUrl(),
  isFetchingPaymentRequest: makeSelectIsFetchingData("paymentRequest"),
  payMonthlyItems: makeSelectPayMonthlyItems(),
  payTodayItems: makeSelectPayTodayItems("OrderSummary"),
  deliveryDetailsItems: makeSelectDeliveryDetailsItems(),
  referralCode: makeSelectReferralCode(),
  eSigned: makeSelectESigned(),
  paymentModes: makeSelectPaymentModes(),
  initialValues: makeSelectOrderSummaryFormInitialValues(),
  selectedNumber: makeSelectFormattedSelectedNumber(),
  addons: makeSelectAddons(),
  planDetails: makeSelectPlanDetails(),
  token: makeSelectSessionToken(),
  sim_count: makeSelectSimCount(),
  defaultPromoCodeOffers: makeSelectDefaultPromoCodeOffers(),
  isFetchingJumio: makeSelectIsFetchingData("jumio"),
  isFetchingJumioSessionToken: makeSelectIsFetchingData("jumioSessionToken"),
  validateIccid: makeSelectValidateIccId(),
  messageData: makeSelectEKYCMessageData(),
  myInfo: makeSelectMyInfo(),
  myInfoIsUsed: makeSelectMyInfoIsUsed(),
  myInfoDetails: makeSelectMyInfoDetails(),
  signPass: makeSelectSignPass(),
  jumioIsUsed: makeSelectJumioIsUsed(),
  jumioData: makeSelectJumioData(),
  jumioSessionToken: makeSelectJumioSessionToken(),
  jumioRedirectUrl: makeSelectJumioRedirectUrl(),
  guestOrder: makeSelectGuestOrder(),
  isWalletPromoCode: makeSelectIsWalletPromoCode(),
  ekycValidation: makeSelectEkycValidation(),
  myInfoIsInvalid: makeSelectMyInfoIsInvalid(),
  appSettings: makeSelectAppSettings(),
  isPrimaryDetailsCompleted: makeSelectIsPrimaryDetailsCompleted(),
  isSecondaryDetailsCompleted: makeSelectIsSecondaryDetailsCompleted(),
  isBillingEmailCompleted: makeSelectBillingEmailCompleted(),
  simCounts: makeSelectSimCountNewAndTransfer()
});

export function mapDispatchToProps(dispatch) {
  return {
    getJumioVerificationUrl: (headersValue, params, callback) => {
      dispatch(getJumioVerificationUrl(headersValue, params, callback));
    },
    jumioVerificationCall: (tokenFromURL, isJumioFulFilementAPI) => {
      if (!tokenFromURL) return;
      if (!isJumioFulFilementAPI) {
        if (tokenFromURL) {
          const params = buildJumioParams(
            tokenFromURL,
            paths.PERSONAL_DETAILS,
            paths.EKYC,
            isJumioFulFilementAPI
          );
          dispatch(getJumioVerificationUrl(params));
        }
      } else {
        window.sessionStorage.setItem("sessionToken", tokenFromURL);
        // dispatch(getJumioSessionToken(
        //   { "Content-Type": "application/json" },
        //   {
        //     subject: getDeviceId()
        //   },
        //   result => {
        //     const jumioSessionToken =
        //       get(result, "token") ||
        //       (typeof result === "string" ? result : "");

        //     if (jumioSessionToken) {
        //       setJumioToken(jumioSessionToken);
        //       const headersValue = {
        //         Authorization: `Bearer ${jumioSessionToken}`
        //       };
        //       const params = buildJumioParams(
        //         tokenFromURL,
        //         paths.PERSONAL_DETAILS,
        //         paths.EKYC,
        //         isJumioFulFilementAPI
        //       );
        //       dispatch(getJumioVerificationFulfillmentUrl(headersValue, params));
        //     }

        //   }))
      }
    },
    createInitialOrder: (orderParams, callback) => {
      dispatch(createInitialOrder(orderParams, callback));
    },
    getJumioSessionToken: (headers, params, callback) => {
      dispatch(getJumioSessionToken(headers, params, callback));
    },
    // getSignPassLinkUrl: (headersValue, params, callback) => {
    //   dispatch(getSignPassLinkUrl(headersValue, params, callback));
    // },
    validateReferralCode: (code, planName) => {
      dispatch(fetchReferralCode({ referral_code: code, plan_name: planName }));
    },
    clearMyInfoDomain: () => {
      dispatch(clearData("myInfoDetails"));
    },
    setMyInfoIsUsed: isUsed => {
      dispatch(
        setData({
          key: "myInfo",
          data: { isUsed }
        })
      );
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: "myInfoIsUsed",
          value: isUsed
        })
      );
    },
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: field,
          value: value
        })
      );
    },
    clearAllMyInfoData: () => {
      dispatch(clearData("myInfoDetails"));
      dispatch(clearData("myInfo"));
    },
    resetReferralCode: () =>
      dispatch(clearData(["referralCode", "selectedAddons"]))
  };
}

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    clearMyInfoUrlParam: () => {
      gotoUrl(window.location.pathname, true, {
        code: null,
        state: null
      });
    },
    clearMyInfoFormFields: (fieldNameToClear = []) => {
      const changeField = dispatchProps.changeField;
      const fieldMap = setMyInfoFieldToClear(fieldNameToClear);
      forEach(fieldMap, fieldName => {
        changeField(fieldName, null);
      });
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(withConnect, memo)(AccountHolderHOC(SmartRender));
